import api from './api';

const officerAssignmentsService = {
  // Get trial assignments for a specific officer
  getTrialAssignments: async (officerId, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add any other filters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.trial_type) queryParams.append('trial_type', params.trial_type);
      if (params.year) queryParams.append('year', params.year);
      
      const queryString = queryParams.toString();
      const url = `/officer-assignments/trials/${officerId}${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching trial assignments:', error);
      throw error;
    }
  },

  // Get trial centre assignments for a specific officer
  getTrialCentreAssignments: async (officerId) => {
    try {
      const response = await api.get(`/officer-assignments/trial-centres/${officerId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching trial centre assignments:', error);
      throw error;
    }
  },

  // Get trial centres with pagination for a specific officer
  getTrialCentres: async (officerId, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add any other filters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.trial_code) queryParams.append('trial_code', params.trial_code);
      
      const queryString = queryParams.toString();
      const url = `/officer-assignments/trial-centres/${officerId}${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching trial centres:', error);
      throw error;
    }
  },

  // Get location assignments for a specific officer
  getLocationAssignments: async (officerId, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add any other filters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.trial_code) queryParams.append('trial_code', params.trial_code);
      if (params.centre_code) queryParams.append('centre_code', params.centre_code);
      
      const queryString = queryParams.toString();
      const url = `/officer-assignments/locations/${officerId}${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching location assignments:', error);
      throw error;
    }
  },

  // Get all assignments for a specific officer
  getAllAssignments: async (officerId) => {
    try {
      const response = await api.get(`/officer-assignments/all/${officerId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all assignments:', error);
      throw error;
    }
  }
};

export default officerAssignmentsService;
